import React from "react";
import Links from "../sub-components/Links";
const { PUBLIC_URL } = process.env;

const Feature9 = () => {

  const dashboard_Video = process.env.REACT_APP_DASHBOARD_VIDEO;

  return (
      <div>
        <section className="section main-banner" id="f9top">
          <video autoPlay muted loop id="bg-video">
            <source
              src={dashboard_Video}
              type="video/mp4"
            />
          </video>

          <div className="video-overlay header-text">
            <div className="caption">
              <h4 style={{ color: "#f5a425" }}>
                Certificates for your respondents{" "}
              </h4>
              <h6>
                Include all the information you need:
                <br /> full name, test name, grade, score, your logo, and more.
              </h6>

              <div className="main-button">
                <div className="scroll-to-section">
                  <a href={`${PUBLIC_URL}/#section3`}>Sign up - it's free</a>
                </div>
              </div>
              <br />
              {/* <div>
                <a style={{ fontSize: "16px", color: "white" }}>Learn more</a>
                <br />
                <GoArrowDown style={{ color: "white" }} />
              </div> */}
            </div>
          </div>
        </section>

        <section className="dark-bg2">
          <div className="container-fluid dark-bg-sec">
            <div className="row f9sec1">
              <div className="col-lg-12 f9sec1head">
                <h4>Prepare online tests and create your own certificates</h4>
              </div>

              <div className="col-lg-6">
                <ul>
                  <li className="f9sec1list">
                    <div className="f9sec1listdiv">
                      <h3>Add respondent data and score</h3>
                      <p>
                        Incorporate the most important data: respondent’s full
                        name, as well as their score achieved during the
                        assessment.
                      </p>
                    </div>
                  </li>
                  <li className="f9sec1list">
                    <div className="f9sec1listdiv">
                      <h3>Add test name and editable placeholders</h3>
                      <p>
                        Test owners can add the name of the specific test for
                        which the certificate is awarded. All placeholders
                        within the certificate are editable.
                      </p>
                    </div>
                  </li>
                  <li className="f9sec1list">
                    <div className="f9sec1listdiv">
                      <h3>Add signatures (including facsimile)</h3>
                      <p>
                        Make your certificates look like paper versions by
                        including signatures, including facsimile signatures.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="col-md-12 col-lg-6 f9sec1img">
                <article className="video-item">
                  <figure>
                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/certificates-tp1.webp`}
                      alt=""
                      // className="background-image"
                    />
                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/purple_curve_bottom.svg`}
                      alt=""
                      className="purple_curve_bottom"
                    />

                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/yellow_curve_top.svg`}
                      alt=""
                      className="yellow_curve_top"
                    />
                  </figure>
                </article>
              </div>
            </div>
          </div>
        </section>

        <section className="img-bg">
          <div className="container-fluid img-bg-sec">
            <div className="row f9sec2">
              <div className="col-md-12 col-lg-6 f9sec2img">
                <article className="video-item">
                  <figure>
                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/certificates-tp2.webp`}
                      alt=""
                    />

                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/yellow.svg`}
                      alt=""
                      className="overlay-image1"
                    />

                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/green_big.svg`}
                      alt=""
                      className="overlay-image2"
                    />
                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/green_big.svg`}
                      alt=""
                      className="overlay-image3"
                    />
                  </figure>
                </article>
              </div>

              <div className="col-lg-6 f9sec2content">
                <h3>Looking for customized certificates?</h3>
                <p>
                  If you require special assessment certificates containing more
                  than our default options, NexTestify will gladly offer you one
                  designed entirely around your needs.
                </p>
              </div>
            </div>
          </div>
        </section>

        <Links />
      </div>
  );
};

export default Feature9;
